<template>
  <div class="component breadcrumbs">
    <ol>
      <li v-for="(crumb, idx) in crumbs" :key="idx">
        <router-link :to="crumb.route" v-if="crumb.route">{{ crumb.label }}</router-link>  
      </li>
      <li v-if="currentLabel">{{ currentLabel }}</li>
    </ol>
  </div>
</template>

<script>

import Category from '@/models/Category';

export default {
  data() {
    return {
      currentVm: null
    }
  },

  watch: {
    $route() {
      this.updateCurrent();
    }
  },

  created() {
    this.updateCurrent();
  }, 

  computed: {
    currentLabel() {
      return this.currentVm ? this.currentVm.breadcrumbLabel : null;
    },

    crumbs() {
      return !this.$route.meta.breadcrumbs || !this.currentVm ? [] : this.$route.meta.breadcrumbs.map(crumb => {
        if (crumb instanceof Object) {
          crumb.label = this.$t(crumb.label);
        } else {
          let crumbType = crumb;
          crumb = {};

          if (crumbType === 'categories') {
            let categoryType = this.currentVm.type;
            crumb.route = { name: `category-${categoryType}` };
            crumb.label = this.$t(`home.tabs.${categoryType}`);
          } else if (crumbType === 'category' && this.currentVm.category && this.currentVm.category.id) {
            let cat = this.currentVm.category;
            crumb.route = { name: `${cat.type}-items`, params: { category: cat.id }}
            crumb.label = cat.name;
          }
        }
        return crumb;
      });
    },
  },

  methods: {
    updateCurrent() {
      // need this wacky setTimeout to yield to the this thread which sync sets instances.default after this call.
      // So set it on the next clock tick.
      setTimeout(() => {
        this.currentVm = this.$route.matched.slice(-1)[0].instances.default;
      }, 0);
    }
  }
}
</script>
<style lang="scss">
.component.breadcrumbs {
  @include font-smaller;
  margin-top: 18px;

  ol {
    @include unlisted;

    li {
      font-family: $fontFamilyDefault;
      display: none;
      
      // For mobile, show only the one upper category
      &:nth-last-child(-n+2) {
        display: inline-block;
      }
      
      &:last-child {
        display: none;
      }

      a::before {
        @include font-awesome-pseudo($fa-var-chevron-left, light);
        color: $colorBlue;
        margin-right: 8px;
        cursor: default;
      }
    }

    @include breakpoint(medium) {
      li {
        display: inline-block;
        color: $colorGray;

        // Last child
        &:last-child {
          display: inline-block;

          &::before {
            @include font-awesome-pseudo($fa-var-chevron-right, light);
            color: $colorGray;
            margin: 0 8px;
          }
        }
        &:first-child::before {
          content: none;
        }

        // Other child
        a::before {
          @include font-awesome-pseudo($fa-var-chevron-right, light);
          color: $colorGray;
          cursor: default;
          margin: 0 8px;
        }
        &:first-child a:before {
          content: none;
        }
      }
    }
  }
}
</style>
